import styled from 'styled-components';

import { ReviewOverrides } from './powerReviewOverrides.js';

export const ReviewDisplay = styled.div`
  ${ReviewOverrides}
`;
